import Vue from 'vue'
import http from '../utils/http';

export default {
    state: {
        monthSales: [],
        monthSales_team: [],
    },
    mutations: {
        loadMonthSales(state, payload) {
			state.monthSales = payload
		},
        loadTeamMonthSales(state, payload) {
			state.monthSales_team = payload
		},
        addMonthSales(state, payload) {
            let index = state.monthSales.length
			Vue.set(state.monthSales, index, payload)   
        },
    },
    actions: {
        //fetch all products by game id & round
        async fetchMonthsales({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)
            //console.log(payload)
            try {
                const result = await http.get(`/month-sales/game/${payload.gameId}?round=${payload.round}`);
                //console.log(result)
                if (result) {
                   const prods = result.data 
                   commit('loadMonthSales', prods) //
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async fetchTeamMonthsales({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)
            const teamId = payload.teamId;
            const gameId = payload.gameId;
            const round = payload.round;
            try {
                const result = await http.get(`/month-sales/team/${teamId}?gameId=${gameId}&round=${round}`);
                //console.log(result)
                if (result) {
                   const prods = result.data 
                   commit('loadTeamMonthSales', prods) //
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async addMonthSales({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            let team = {};
            const trademark = { name: payload.trademark };

            if (payload.team) {
                team = payload.team;
                delete payload.team;
            }

            try {
                const result = await http.post(`/month-sales`, payload);
                
                if (result) {
                    const prod = await result.data;
                    prod.team = team;
                    prod.trademark = trademark;
                    commit('addMonthSales', prod)
                }              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async calculateMonthSales({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)
            //console.log(payload)
            try {
                const result = await http.get(`/month-sales/calculate/${payload.gameId}?round=${payload.round}`);
                //console.log(result)
                if (result) {
                   const prods = result.data 
                   commit('loadMonthSales', prods) //
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
    },
    getters: {
        monthSales(state) {
            return state.monthSales;
        },
        monthSales_team(state) {
            return state.monthSales_team;
        },
    }
}